export const SUPPORTED_VOICE_LANGUAGES = ['en', 'ar', 'hi', 'ur', 'bn', 'fr', 'de', 'zh', 'ja'] as const;

export const BUILTIN_VOICE_OPTIONS = [
  { id: 'sarah', name: 'Sarah', gender: 'Female', description: 'Warm and professional' },
  { id: 'michael', name: 'Michael', gender: 'Male', description: 'Clear and authoritative' },
  { id: 'emma', name: 'Emma', gender: 'Female', description: 'Friendly and approachable' },
  { id: 'james', name: 'James', gender: 'Male', description: 'Calm and reassuring' },
  { id: 'sophia', name: 'Sophia', gender: 'Female', description: 'Energetic and precise' },
] as const;

export const RECOMMENDED_VOICE_IDS: Record<string, { id: string; nameKey: string }> = {
  en: { id: 'XB0fDUnXU5T4htws2HDM', nameKey: 'voice.settings.recommendedVoices.en' },
  ar: { id: '3nav5pHC1EYvWOd5LmnA', nameKey: 'voice.settings.recommendedVoices.ar' },
  hi: { id: 'bUTE2M5LdnqaUCd5tJB3', nameKey: 'voice.settings.recommendedVoices.hi' },
  ur: { id: 'bUTE2M5LdnqaUCd5tJB3', nameKey: 'voice.settings.recommendedVoices.ur' },
  bn: { id: 'bUTE2M5LdnqaUCd5tJB3', nameKey: 'voice.settings.recommendedVoices.bn' },
  fr: { id: 'XB0fDUnXU5T4htws2HDM', nameKey: 'voice.settings.recommendedVoices.fr' },
  de: { id: 'XB0fDUnXU5T4htws2HDM', nameKey: 'voice.settings.recommendedVoices.de' },
  zh: { id: 'XB0fDUnXU5T4htws2HDM', nameKey: 'voice.settings.recommendedVoices.zh' },
  ja: { id: 'XB0fDUnXU5T4htws2HDM', nameKey: 'voice.settings.recommendedVoices.ja' },
};
